// OrderItem.js
import React from "react";

// MUI components
import { Box, Typography, Popper } from "@material-ui/core";

// Entities
import { PortState } from "../../../entities/PortDashboardState";

// // Local components
import { BusyPortOrders } from "./BusyPortOrders";
import { FreePortOrders } from "./FreePortOrders";

// Styled components / styles
import {
	CleanTooltipPaper,
	PortSubtitle,
	PortTitle,
	TooltipContent,
	TooltipHeader,
	StatusIndicator,
} from "../styles";

export const PortTooltip = ({
	open,
	anchorEl,
	port,
	color,
	minutes,
	onMouseEnter,
	onMouseLeave,
	translate,
	port_taken_duration
}) => {
	const getPortStatusText = (state) => {
		switch (state) {
			case PortState.FREE:
				return translate("resources.dashboard_ports.port.status.free");
			case PortState.BUSY:
				return translate("resources.dashboard_ports.port.status.busy");
			case PortState.BLOCKED:
				return translate("resources.dashboard_ports.port.status.blocked");
			default:
				return translate("resources.dashboard_ports.port.status.unknown");
		}
	};

	const orders = port.port_orders || [];
	return (
		<Popper
			open={open}
			anchorEl={anchorEl}
			placement="top"
			style={{ zIndex: 1300, pointerEvents: "auto" }}
			modifiers={[
				{
					name: "offset",
					options: {
						offset: [0, 8],
					},
				},
			]}
		>
			<CleanTooltipPaper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
				<TooltipHeader>
					<Box display="flex" alignItems="center" justifyContent="space-between">
						<Box>
							<PortTitle>{port.name}</PortTitle>
							<Box display="flex" alignItems="center">
								<StatusIndicator bgcolor={color} />
								<PortSubtitle>{getPortStatusText(port.state)}</PortSubtitle>
							</Box>
						</Box>
						<Box textAlign="right">
							<Typography style={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
								{port.state === PortState.BUSY
									? port_taken_duration !== null && port_taken_duration !== "N/A"
										? `${port_taken_duration}`
										: "N/A"
									: minutes !== null && minutes !== "N/A"
									? `${minutes}`
									: "N/A"}
							</Typography>
							<Typography style={{ color: "rgba(255,255,255,0.9)", fontSize: "11px" }}>
								{minutes !== null && minutes !== "N/A"
									? translate("resources.dashboard_ports.minutes_left")
									: ""}
							</Typography>
						</Box>
					</Box>
				</TooltipHeader>

				<TooltipContent>
					{port.state === PortState.BUSY ? (
						<BusyPortOrders orders={orders} terminal_id={port.terminal_id} translate={translate} />
					) : (
						<FreePortOrders orders={orders} translate={translate} />
					)}
				</TooltipContent>
			</CleanTooltipPaper>
		</Popper>
	);
};
